import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'

import type { BrazeCampaignDetail, BrazeCanvasDetail } from '../api'
import { getCanvasDetail } from '../api'
import { importKeys } from '../queryKeys'

export const normalizeCanvasDetail = (
  canvas: BrazeCanvasDetail
): BrazeCampaignDetail => ({
  integration: canvas.integration,
  campaign_id: canvas.canvas_id,
  campaign_name: canvas.canvas_name,
  description: canvas.description,
  tags: canvas.tags,
  channels: canvas.channels,
  messages: canvas.steps.flatMap((step) => step.messages),
})

const useGetCanvasDetailQuery = ({
  integration,
  canvasId,
}: {
  integration: string
  canvasId: string | null
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { content } = useContent()

  const projectId =
    content?.elements[0]?.optimization_settings?.configuration?.project_id ?? ''

  return useQuery({
    queryKey: importKeys.canvasDetail({
      accountId,
      projectId,
      integration,
      canvasId: canvasId ?? '',
    }),
    queryFn: () =>
      getCanvasDetail({
        accountId,
        projectId,
        integration,
        canvasId: canvasId!,
      }),
    enabled: !!canvasId && !!projectId,
    select: normalizeCanvasDetail,
  })
}

export default useGetCanvasDetailQuery
